/**
 * An example of this would be if for some reason, we try to do a chart user action 
 * on a symbol that does not belong to this trade plan.
 * 
 * {"errorType":"TRADE_PLAN_ERROR","notificationType":"ERROR","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "INVALID_SYMBOL",
	"statusDetails": {"actualSymbol":"A","expectedSymbol":"b"},
	"date": "2022-02-21T09:45:09.726-0500",
	"timestamp": "1645454709726"
}

 * @param {*} statusDetails 
 * @returns object with fields:
 * 1) actionSymbol: the symbol we recieve that the action for
 * 2) expectedSymbol: the symbol we would have expected relative to this trade plan
 */
export function invalidSymbolParser(statusDetails) {
  const parsedObj = {
    actualSymbol: null,
    expectedSymbol: null,
  };
  if (statusDetails) {
    parsedObj.actualSymbol = statusDetails.actualSymbol ?? null;
    parsedObj.expectedSymbol = statusDetails.expectedSymbol ?? null;
  }

  return parsedObj; 
}
